module.exports = __webpack_public_path__ + "static/wall-street-logo-a1ab58ae9af9ae9543a6d3cc5558a3b7.svg";